export default __webpack_public_path__ + "static/media/mobile-6.10d4d69b.png";